import {
  AccountCard,
  AccountContent,
  AccountHead,
  AccountTitle,
  AccountWrap,
} from '@/shared/components/account/AccountElements';
import { useAuth } from '@/context/AuthContext'
import GoogleSignIn from './components/GoogleSignIn';

const LogIn = () => {
  const { login } = useAuth()

  const handleGoogleLoginSuccess = (response) => {
    console.log('Google login success:', response);
    login(response);
  };

  const handleGoogleLoginFailure = (error) => {
    console.error('Google login failed:', error);
    console.error('Error details:', {
      error: error.error,
      details: error.details,
      message: error.message
    });
    
    let errorMessage = 'Falha no login com o Google. Por favor, tente novamente.';
    
    if (error.error === 'popup_closed_by_user') {
      errorMessage = 'Login cancelado pelo usuário.';
    } else if (error.error === 'access_denied') {
      errorMessage = 'Acesso negado. Verifique se você está usando uma conta @transben.com.br.';
    } else if (error.error === 'immediate_failed') {
      errorMessage = 'Erro de configuração do Google OAuth. Verifique as configurações.';
    }
    
    alert(errorMessage);
  };

  return (
    <AccountWrap>
      <AccountContent>
        <AccountCard>
          <AccountHead>
            <AccountTitle>Bem vindo
            </AccountTitle>
            <h4 className="subhead">Sistema logístico</h4>
          </AccountHead>
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <GoogleSignIn
              clientId="452506524570-hln5n5eiulg5jnt8qs9cp6pams523jdb.apps.googleusercontent.com"
              onSuccess={handleGoogleLoginSuccess}
              onFailure={handleGoogleLoginFailure}
            />
          </div>
        </AccountCard>
      </AccountContent>
    </AccountWrap>
  );
}
export default LogIn;
